import { Action } from '@bridebook/web/lib/types';
import { TSectionName } from '../types';

export enum WeddingWebsiteAnalyticEvents {
  INTERACTED_WITH_WEDDING_WEBSITE = 'Interacted with wedding website',
  COMPLETED_FEATURE_ONBOARDING_STEP = 'Completed feature onboarding step',
  SAVED_WEDDING_WEBSITE = 'Saved wedding website',
  SUPPLIER_AND_COUPLE_STARTED_COLLABORATING = 'Supplier and couple started collaborating',
  BOOKED_SUPPLIER = 'Booked supplier',
  INTERACTED_WITH_WEDDING_WEBSITE_THEME_GENERATOR_AI = 'Interacted with wedding website theme generator AI',
}

export const weddingWebsiteAnalyticsPrefix = '[Analytics][Wedding Website]';

export enum WeddingWebsiteAnalyticsTypes {
  NAVIGATION_CLICKED = 'Navigation clicked',
  SECTION_CLICKED = 'Section clicked',
  FEATURE_ONBOARDING_STARTED = 'Started feature onboarding',
  FEATURE_ONBOARDING_STEP_COMPLETED = 'Completed feature onboarding step',
  FEATURE_ONBOARDING_FINISHED = 'Finished feature onboarding',
  PERFORMED_SUPPLIER_SEARCH_BY_NAME = '[Analytics][Wedding Website] Performed supplier search by name',
  INTERACTED_WITH_WEDDING_WEBSITE = `[Analytics][Wedding Website] Interacted with wedding website`,
  SAVED_WEDDING_WEBSITE = '[Analytics][Wedding Website] Saved wedding website',
  SUPPLIER_AND_COUPLE_STARTED_COLLABORATING = '[Analytics][Wedding Website] Supplier and couple started collaborating',
  BOOKED_SUPPLIER = '[Analytics][Wedding Website] Booked supplier',
  INTERACTED_WITH_WEDDING_WEBSITE_THEME_GENERATOR_AI = '[Analytics][Wedding Website] Interacted with wedding website theme generator AI',
}

export type WeddingWebsiteSectionType =
  | 'weddingWebsites_details'
  | 'weddingWebsites_design'
  | 'weddingWebsites_security'
  | 'weddingWebsites_rsvp'
  | 'weddingWebsites_guestlist'
  | 'weddingWebsites_paper&Invites';

export type WeddingWebsiteCTAType =
  | 'Wedding details'
  | 'Website design'
  | 'Privacy & Access'
  | 'Set up RSVP'
  | 'Guest list'
  | 'Invites & Paper';

export interface WeddingWebsiteOnboardingAction extends Action {
  type: WeddingWebsiteAnalyticsTypes.FEATURE_ONBOARDING_STARTED;
  payload: {
    category: string;
    location: string;
  };
}

export interface SectionConfig {
  section: WeddingWebsiteSectionType;
  cta: WeddingWebsiteCTAType;
}

export interface IInteractedWithWeddingWebsiteAnalytics {
  event?: WeddingWebsiteAnalyticEvents;
  category?: string;
  action: string;
  location: string;
  section: string;
  element: string;
  elementLabel?:
    | string
    | {
        font: string;
        palette: string;
        layout?: 'classic' | 'split';
      };
}

export interface IGenericWeddingWebsiteAnalytics {
  event?: WeddingWebsiteAnalyticEvents;
  [key: string]: string | WeddingWebsiteAnalyticEvents | undefined;
}

export interface SavedWeddingWebsiteAnalytics {
  event: WeddingWebsiteAnalyticEvents.SAVED_WEDDING_WEBSITE;
  location: 'preview' | 'details' | 'design' | 'desktopHeader' | 'fullPagePreview' | 'settings';
  section?: string;
  cta?: string;
  rsvpVisible: boolean;
  ourStoryVisible: boolean;
  eventsVisible: boolean;
  faqVisible: boolean;
  additionalSections: boolean;
  venuePhotos: boolean;
  giftListVisible: boolean;
  placesToStayVisible: boolean;
  sectionsOrderDict?: Record<number, TSectionName>;
  defaultOrderingFlag?: boolean;
  category: 'weddingWebsites';
  themeGeneratedAi: boolean;
}

export interface IInteractedWithWeddingWebsiteThemeGeneratorAIAnalytics {
  action: 'clicked' | 'sent';
  location: 'weddingWebsites' | 'design' | 'themeGeneratorAi';
  section: 'design' | 'themeGeneratorAi' | 'themeConversation';
  element:
    | 'supportMessage'
    | 'messageComposer'
    | 'suggestedPrompt'
    | 'cta'
    | 'icon'
    | 'drawerOrModal';
  elementLabel: string;
  parentPromptId?: string;
  childPromptId?: string;
}
